import { DefaultOptions, useQuery } from "@tanstack/react-query";

import { AvailableReservationTimeListParams, getAvailableReservationTimeAsync, getProductDetailAsync } from "src/api/product/product-api";
import { axiosInstance } from "src/utils";

/**
 * //예약 가능 기간
 * @param param defaultOptions:DefaultOptions["queries"]
 * @returns AvailableReservationTime[]
 */
const useGetAvailableReservationTime = ({
  AvailableReservationTimeListParams,
  defaultOptions,
}: {
  AvailableReservationTimeListParams: AvailableReservationTimeListParams;
  defaultOptions?: DefaultOptions["queries"];
}) => {
  const _defaultOptions = defaultOptions as unknown as Object;
  const query = useQuery({
    queryKey: ["getAvailableReservationTimeAsync", AvailableReservationTimeListParams],
    queryFn: () => getAvailableReservationTimeAsync(axiosInstance, AvailableReservationTimeListParams).then((res) => res?.data?.data?.content),

    enabled: !!AvailableReservationTimeListParams,
    retryOnMount: false,
    staleTime: 1000,
    // refetchOnMount: false,
    ...(_defaultOptions && _defaultOptions),
  });

  return { ...query };
};

export default useGetAvailableReservationTime;
